import React from 'react';
import styled from '../../../libs/styled.es.js';

const Wrapper = styled.div`
  padding: 1rem;
  text-align: center;
  .title {
    margin-bottom: 0;
  }
`;
const ModalHeader = ({
  children,
  className
}) => /* @__PURE__ */ React.createElement(Wrapper, {
  className
}, /* @__PURE__ */ React.createElement("h5", {
  className: "title"
}, children));

export { ModalHeader };
